import placements from "@/placements"
import { AttributedCampaignResult, EventResponseMessage } from "@/types"

export default async function (response: EventResponseMessage, targets: Record<string, HTMLElement>) {
  // processedRecommendations are recommendations processed by merchant after nosto initially rendered them.
  const campaigns = (response.processedRecommendations || response.recommendations) as Record<
    string,
    AttributedCampaignResult | string
  >
  await placements.injectCampaigns(campaigns, targets)
}
